import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ModuleManagerExportFormat } from 'src/shared/models/module-manager/module-manager-options.model';
import { ReportingSetData } from './cxone-quality-evaluations.model';
import { ApiResponse } from 'src/shared/models/api-response.model';
 
@Injectable({
    providedIn: 'root'
})
export class CxoneQualityEvaluationsService {

    constructor(
        private cvApiService: CVApiService
    ) { }

    public async loadQualityEvaluationsData(moduleKey: string, reportName: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (err) {
            console.error("Failed getting module render endpoint");
        }

        try {
            const url = `/api/v1/dashboards/modules/qualityevaluations/${reportName}/${moduleKey}/data?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            const response = await this.cvApiService.get<any>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed getting data for Quality Evaluations module");
            throw err;
        }
    }

    public async getReportList(): Promise<ApiResponse<ReportingSetData[]>> {

        try {
            const url = `/api/v1/dashboards/modules/qualityEvaluations/report-definitions`;
            const response = await this.cvApiService.get<ReportingSetData[]>(url);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed to get report definitions for Quality Evaluations module");
            throw err;
        }
    }
 
    async LoadDataForExport(moduleKey: string, reportName: string, format: ModuleManagerExportFormat): Promise<any> {
        try {
            const moduleRenderURL = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const url = `/api/v1/dashboards/modules/qualityEvaluations/${reportName}/${moduleKey}/export?format=${format}`;
 
            const response = await this.cvApiService.get<string>(url, moduleRenderURL);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        }
        catch (err) {
            console.error("Failed to get quality evaluations export data");
            throw err;
        }
    }
}